<template>
  <event-form
    action="create"
    :loading="loading"
    :updating="creating"
    :error-messages="errorMessages"
    :handle-submit="handleFormSubmit"
    :handle-discard="handleDiscard"
  />
</template>

<script>
// eslint-disable-next-line object-curly-newline, no-unused-vars
import { computed, ref, getCurrentInstance } from '@vue/composition-api'

import EventForm from './event-form/EventForm.vue'

export default {
  components: {
    EventForm,
  },
  setup() {
    const vm = getCurrentInstance().proxy

    const errorMessages = ref([])

    const loading = ref(false)
    const creating = computed(() => vm.$store.getters['events/creating'])

    const handleFormSubmit = formData => {
      vm.$store
        .dispatch('events/create', formData)
        .then(res => {
          if (res?.status === 200 && res?.data?.data?.event) {
            const eventId = res.data.data.event.id

            vm.$router.replace({
              name: 'event-view',
              params: {
                id: eventId,
              },
            })
          }
        })
        .catch(err => {
          if (err?.data?.errors) {
            errorMessages.value = err.data.errors
          }
        })
    }

    const handleDiscard = () => vm.$router.replace({ name: 'event-list' })

    return {
      loading,
      creating,

      errorMessages,

      handleFormSubmit,
      handleDiscard,
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
